/**
 * Suppliers paste empty paragraphs (<p> </p>, <p><br></p>, &nbsp;) into product descriptions. They show up as 60px gaps,
 * so paragraphs that hold nothing visible are hidden. Product pages only; the text itself is not changed.
 */
document.querySelectorAll('.product-information rte-formatter p').forEach((p) => {
  if (!p.textContent.replace(/[\s\u00a0]/g, '') && !p.querySelector('img, video, iframe')) p.hidden = true;
});
